(function () {
  function initScrollSteps(container) {
    if (!container || container.dataset.ssInit === 'true') return;
    container.dataset.ssInit = 'true';
    container.classList.add('js-enabled');

    var timeline = container.querySelector('.scroll-steps__timeline');
    var line = container.querySelector('.scroll-steps__line');
    var list = container.querySelector('[data-ss-list]');
    var fill = container.querySelector('[data-ss-fill]');
    var items = Array.prototype.slice.call(container.querySelectorAll('[data-ss-item]'));

    if (!timeline || !line || !list || !fill || !items.length) return;

    var firstCenter = 0;
    var trackHeight = 0;

    function markerCenter(item) {
      var marker = item.querySelector('[data-ss-marker]');
      if (!marker) return 0;
      var rect = marker.getBoundingClientRect();
      var timelineRect = timeline.getBoundingClientRect();
      return rect.top + rect.height / 2 - timelineRect.top;
    }

    // Position the line so it spans exactly from the first dot's center
    // to the last dot's center, instead of the full (padded) list height —
    // otherwise the fill never visually "completes" at the last step.
    function layoutLine() {
      firstCenter = markerCenter(items[0]);
      var lastCenter = markerCenter(items[items.length - 1]);
      trackHeight = Math.max(0, lastCenter - firstCenter);
      line.style.top = firstCenter + 'px';
      line.style.height = trackHeight + 'px';
    }

    // Reveal each step once, as it enters the viewport.
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );
      items.forEach(function (item) {
        revealObserver.observe(item);
      });
    } else {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }

    // Progressive line fill + active step/title color, tied to scroll position.
    var referenceRatio = 0.55; // point on screen (as a fraction of viewport height) that "activates" a step

    function update() {
      var referenceY = window.innerHeight * referenceRatio;
      var activeIndex = -1;

      items.forEach(function (item, index) {
        var marker = item.querySelector('[data-ss-marker]');
        if (!marker) return;
        var markerRect = marker.getBoundingClientRect();
        var reached = markerRect.top <= referenceY;
        item.classList.toggle('is-active', reached);
        if (reached) activeIndex = index;
      });

      if (activeIndex === -1) {
        fill.style.height = '0px';
      } else {
        var activeCenter = markerCenter(items[activeIndex]);
        var offset = activeCenter - firstCenter;
        var clamped = Math.max(0, Math.min(offset, trackHeight));
        fill.style.height = clamped + 'px';
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    function onResize() {
      layoutLine();
      update();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    layoutLine();
    update();

    // Images loading can change each item's height after the first layout
    // pass (and therefore the dot positions), so re-measure once they're in.
    var imgs = container.querySelectorAll('img');
    imgs.forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', onResize, { once: true });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.scroll-steps').forEach(initScrollSteps);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-init when a section is added/rendered through the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();